import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { CoachModel, CoachViewType, ViewPayload } from 'common/models/coach.model';

// identifier
export const COACH_SLICE_ID = 'coach';

// default state
const initialState: CoachModel = {
  view: 'totals',
  currentTeamDetailColumnsList: {},
  viewTeamNamesOnMetricPlotOn: ['totals', 'avg_perday', 'avg_perprofile'],
};

//slice
const coachSlice = createSlice({
  name: COACH_SLICE_ID,
  initialState,
  reducers: {
    setView: (state: CoachModel, action: PayloadAction<ViewPayload>) => {
      state.view = action.payload;
    },
    updateCurrentList: (state: CoachModel, action: PayloadAction<string[]>) => {
      state.currentTeamDetailColumnsList[state.view] = action.payload;
    },
    setPlotTeamNamesOnView: (
      state: CoachModel,
      action: PayloadAction<{ view: CoachViewType; value: boolean }>
    ) => {
      const { view, value } = action.payload;
      if (value && !state.viewTeamNamesOnMetricPlotOn.includes(view)) {
        state.viewTeamNamesOnMetricPlotOn = [...state.viewTeamNamesOnMetricPlotOn, view];
      } else if (!value && state.viewTeamNamesOnMetricPlotOn.includes(view)) {
        state.viewTeamNamesOnMetricPlotOn = state.viewTeamNamesOnMetricPlotOn.filter(
          (i) => i !== view
        );
      }
    },
  },
});

//selectors
export const selectCoachView = (state: RootState): CoachViewType => state.coach.view;

export const selsectCoachList = (state: RootState) =>
  state.coach.currentTeamDetailColumnsList[state.coach.view];

export const selectPlotTeamNamesOnView = (state: RootState, view: CoachViewType) => {
  const index = state.coach.viewTeamNamesOnMetricPlotOn.findIndex((i) => i === view);
  return index > -1 ? true : false;
};

//actions
export const { setView, updateCurrentList, setPlotTeamNamesOnView } = coachSlice.actions;

//reducer
export default coachSlice;
